import React from 'react';

/**
 * Portada de categorías: en vez de tirar todos los productos de una, muestra
 * la lista de categorías y el cliente entra a la que le interesa.
 * Se activa con el estilo `vista_catalogo: 'categorias'` (ver themeService).
 *
 * Las categorías no tienen imagen propia en la BD, así que la miniatura se
 * saca del primer producto de esa categoría que tenga foto. Si no hay ninguna,
 * cae en un círculo con la inicial — sin pantallas nuevas ni migración.
 */
function CatalogoCategorias({ categorias = [], onSelect, colorPrimario = '#F26B21', tarjetaRadio = 'redondeado', titulo = 'Elige una categoría' }) {
    const radios = { cuadrado: '6px', redondeado: '14px', extra: '24px' };
    const radio = radios[tarjetaRadio] || '14px';

    if (!categorias.length) return null;

    return (
        <div className="lista-categorias">
            <style>{`
                .lista-categorias { padding: 4px 0 12px; }
                .lc-titulo {
                    font-size: 13px;
                    color: #6c757d;
                    margin: 4px 4px 10px;
                    font-weight: 500;
                }
                .lc-item {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    width: 100%;
                    background: #fff;
                    border: none;
                    border-radius: ${radio};
                    padding: 10px 14px 10px 10px;
                    margin-bottom: 8px;
                    text-align: left;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    transition: transform .15s ease, box-shadow .15s ease;
                }
                .lc-item:active { transform: scale(0.985); }
                .lc-item:hover { box-shadow: 0 3px 10px rgba(0,0,0,0.10); }
                .lc-thumb {
                    width: 58px; height: 58px;
                    border-radius: 12px;
                    object-fit: cover;
                    flex: none;
                    background: #f1f3f5;
                }
                .lc-inicial {
                    width: 58px; height: 58px;
                    border-radius: 12px;
                    flex: none;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 22px; font-weight: 700; color: #fff;
                }
                .lc-texto { flex: 1; min-width: 0; }
                .lc-nombre {
                    font-size: 16px; font-weight: 600; color: #1a1c1d;
                    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }
                .lc-cantidad { font-size: 13px; color: #868e96; margin-top: 2px; }
                .lc-flecha { font-size: 20px; color: #ced4da; flex: none; line-height: 1; }

                @media (min-width: 992px) {
                    .lista-categorias {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 0 14px;
                    }
                    .lc-titulo { grid-column: 1 / -1; }
                }
            `}</style>

            <div className="lc-titulo">{titulo}</div>

            {/* La llave y el onSelect usan SIEMPRE cat.nombre (el original): es con
                ese nombre que se filtran los productos. nombreMostrar es solo lo que
                ve el cliente, traducido si cambio el idioma. */}
            {categorias.map(cat => (
                <button
                    key={cat.nombre}
                    className="lc-item"
                    onClick={() => onSelect(cat.nombre)}
                >
                    {cat.imagen
                        ? <img src={cat.imagen} alt={cat.nombreMostrar || cat.nombre} className="lc-thumb" />
                        : <div className="lc-inicial" style={{ backgroundColor: colorPrimario }}>
                            {(cat.nombreMostrar || cat.nombre || '?').charAt(0).toUpperCase()}
                        </div>
                    }
                    <div className="lc-texto">
                        <div className="lc-nombre">{cat.nombreMostrar || cat.nombre}</div>
                        <div className="lc-cantidad">
                            {cat.cantidad} {cat.cantidad === 1 ? 'producto' : 'productos'}
                        </div>
                    </div>
                    <div className="lc-flecha">›</div>
                </button>
            ))}
        </div>
    );
}

export default CatalogoCategorias;
